export default __webpack_public_path__ + "static/media/heating.f2f522c6.png";